import React from "react";
import styled, { keyframes } from "styled-components";
import {
  StyledBackButton,
  StyledCreateShiftContainer,
  StyledDailyView,
  StyledDayViewShiftsContainer,
  StyledOpenShiftsRow
} from "./daily-view.styles";
import { StyledOpenShiftEmptyCard } from "../../../GridCard/grid-card.styles";

const pulseAnimation = keyframes`
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
`;

const SkeletonCard = styled.div`
  width: 95%;
  height: 50px;
  border-radius: 5px;
  background: #f0f0f0;
  animation: ${pulseAnimation} 1.5s infinite ease-in-out;
  margin: 0 1px;
`;

const DailyViewSkeleton = () => {
  // Show skeleton for both day and night shifts (5 cards each)
  return (
    <StyledDailyView>
      <StyledBackButton />
      <StyledCreateShiftContainer>
        <StyledOpenShiftEmptyCard isDailyView disabled lineHeight="4px" />
      </StyledCreateShiftContainer>
      <StyledDayViewShiftsContainer>
        <StyledOpenShiftsRow>
          {Array(5)
            .fill()
            .map((_, i) => (
              <SkeletonCard key={`day-skeleton-${i}`} />
            ))}
        </StyledOpenShiftsRow>
        <StyledOpenShiftsRow>
          {Array(5)
            .fill()
            .map((_, i) => (
              <SkeletonCard key={`night-skeleton-${i}`} />
            ))}
        </StyledOpenShiftsRow>
      </StyledDayViewShiftsContainer>
    </StyledDailyView>
  );
};

export default DailyViewSkeleton;
